import { Form } from 'antd'
import styled from 'styled-components'

export const CreateFarmUserDrawerStyle = styled(Form)`
  display: flex;
  padding-top: 25px;
  padding-bottom: 40px;
  
  .inputs {
    display: flex;
    flex-direction: column;

    gap: 10px;
    width: 150%;

    .collum {
      display: flex;
      gap: 15px;
      justify-content: flex-start;
    }

    .title {
      font-weight: 600;
      font-size: 32px;
      margin-bottom: 20px;
    }
  }

  .half-collum {
    width: 100%;
  }

  .full-collum {
    width: 49%;
  }

  .button-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: calc(100% - 20px);
    padding: 10px;
    background-color: ${(props) => props.theme.white};
    box-shadow: ${(props) => props.theme.buttonContainer};
  }

  .submit-button {
    text-align: left;
    width: 50% !important;
    margin-left: auto;
    padding-right: 5px;
  }

  .back-button {
    flex: 1;
    text-align: left;
  }
  
  .quill {
      position: relative;
      width: 95%;
      height: 200px;
  }

  .aditional-options {
    margin-top: 80px;
  }
`